import React from "react";
import HelpVideosStore from "./views/_partials/helpVideosStore";

const HelpVideos = () => {
  return (
    <div className="dashboard-wrapper-full">
      <div className="section-wrapper">
        <HelpVideosStore />
      </div>
    </div>
  );
};

export default HelpVideos;
